export function NewStateTypeCtrl ($scope, $uibModalInstance, $translate, workshopAPI, messages, country_code) {

	$scope.state_type = {
		country_code : country_code,
		code: '',
		description: ''
	}

	$scope.cancel = function () {
		$uibModalInstance.dismiss();
	};

	$scope.save = function (form) {
		workshopAPI.post('/state_types', $scope.state_type, 'state_type')
			.then(function (type) {
				messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.STATE_ADDED_TO_COUNTRY'), 'success');
				$uibModalInstance.close(type);
			}, function (err) {
				messages.error(err, form);
			});
	};

}